// extracted by mini-css-extract-plugin
module.exports = {"image-wrapper":"fluid-image_image-wrapper__1kDOl"};